// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3WFIx","row":"styles_row__2v4dq"};